import React from 'react';
import {ButtonNew} from 'components/ButtonNew';
import Icon from 'components/Icon';
import cs from 'classnames';
import style from './style.module.scss';
import {CART_LINK} from 'core/modules/routing/constants';

interface IInCartButtonProps {
    className?: string;
    onClick?: () => void;
}

export const ToCartButton = (props: IInCartButtonProps) => {
    const {className, onClick} = props;

    return (
        <ButtonNew
            className={cs(style.toCartButton, className)}
            variants={{DT: 'medium', TB: 'small', MB: 'small'}}
            isSquare={true}
            theme={'black'}
            onClick={onClick}
            href={CART_LINK}
        >
            <Icon icon={'arrow-m'} />
        </ButtonNew>
    );
};
